export const Sounds: Array<{ name: string; sound: HTMLAudioElement | null }> = [
    { name: 'None', sound: null },
    { name: 'High Bing', sound: new Audio('/sounds/bing-sound.mp3') },
    { name: 'Low Bing', sound: new Audio('/sounds/low-bing-sound.mp3') },
    { name: 'Game Bing', sound: new Audio('/sounds/game-bing-sound.mp3') },
    { name: 'Alarm', sound: new Audio('/sounds/alarm-sound.mp3') },
    { name: 'Bell', sound: new Audio('/sounds/bell-sound.mp3') },
];
